import { useCallback } from 'react';
import type {
	ChildResult,
	CommandSections,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_PRIORITY } from '../../../../../common/ui/constants.tsx';
import { useGetQuickSearchIssueCommands } from '../../../../../common/ui/issue/index.tsx';
import type {
	GetQuickSearchChildResultProps,
	UseGetChildResult,
} from '../../../../../common/ui/types.tsx';
import { messages } from './messages.tsx';

const SECTION_ID = 'jira.issue';

export const useGetSearchIssuesChildResult: UseGetChildResult = () => {
	const { formatMessage } = useIntl();

	const { getQuickSearchIssueCommands } = useGetQuickSearchIssueCommands({
		section: SECTION_ID,
		errorMessage: formatMessage(
			fg('jira-issue-terminology-refresh-m3')
				? messages.issueErrorIssueTermRefresh
				: messages.issueError,
		),
		showViewAll: true,
	});

	const getChildResult = useCallback(
		(props: GetQuickSearchChildResultProps): ChildResult => {
			const sections: CommandSections = {
				[SECTION_ID]: {
					id: SECTION_ID,
					name: formatMessage(
						fg('jira-issue-terminology-refresh-m3')
							? messages.issuesIssueTermRefresh
							: messages.issues,
					),
					priority: QUICK_SEARCH_PRIORITY.ISSUES,
				},
			};

			const commands = getQuickSearchIssueCommands(props);

			return {
				sections,
				commands,
			};
		},
		[formatMessage, getQuickSearchIssueCommands],
	);

	return { getChildResult };
};
